import React from "react";
import { Alert } from "@material-ui/lab";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import TelegramManagersItem from "./TelegramManagersItem";

const TelegramManagersList = ({ managers, onEdit, onDelete, onAttrs, onToggled, setNotification, t }) => {
  if (!managers) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (managers.length === 0) {
    return <Alert severity="warning">{t("managers.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable width="1440" size="14" className="manager-list">
        <StyledTableHead scroll="auto" col="9" className="manager-list__head">
          <div>{t("managers.table.status")}</div>
          <div>{t("managers.table.name")}</div>
          <div>{t("managers.table.type")}</div>
          <div>{t("bots.table.project")}</div>
          <div>{t("managers.table.telegramId")}</div>
          <div>{t("managers.table.username")}</div>
          <div>{t("managers.table.email")}</div>
          <div>{t("managers.table.createdAt")}</div>
          <div>{t("managers.table.actions")}</div>
        </StyledTableHead>
        <StyledTableBody>
          {managers.map(manager => (
            <TelegramManagersItem
              key={manager.id}
              manager={manager}
              onEdit={onEdit}
              onDelete={onDelete}
              onAttrs={onAttrs}
              onToggled={onToggled}
              setNotification={setNotification}
              t={t}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default TelegramManagersList;